module.exports = __webpack_public_path__ + "img/stock6.872f5c1d.png";